
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shorts/[postId]",
      function () {
        return require("private-next-pages/shorts/[postId]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shorts/[postId]"])
      });
    }
  